import Awesomplete from "awesomplete";
import React, { Component, Fragment } from "react";
import Nestable from "react-nestable";
import CostEstimateRow from "./CostEstimateRow";
import DefaultPopup from "./common/defaultPopup";
import { findArticles } from "../services/articlesService";
import infoBoardsCalc from "../services/infoBoardsCalcService";
import Select from "./common/select";

class CostEstimateRows extends Component {
    tableHeadings = [
        { name: "Artikelnr.", align: "left", styles: { width: "8%", maxWidth: '110px' } },
        { name: "Benämning", align: "left", styles: { width: "22%", maxWidth: '500px' } },
        { name: "Antal", align: "right", styles: { width: "5%", maxWidth: '100px' } },
        { name: "Enhet", align: "left", styles: { width: "4%", maxWidth: '45px' } },
        { name: "Bredd", align: "right", styles: { width: "5%", maxWidth: '80px' } },
        { name: "Längd", align: "right", styles: { width: "5%", maxWidth: '80px' } },
        { name: "Pass", align: "right", styles: { width: "5%", maxWidth: '50px' } },
        { name: "Vikt i kg", align: "right", styles: { width: "5%", maxWidth: '100px' } },
        { name: "Tid", align: "right", styles: { width: "5%", maxWidth: '100px' } },
        { name: "Extra", align: "right", styles: { width: "5%", maxWidth: '100px' } },
        { name: "Overhead", align: "right", styles: { width: "5%", maxWidth: '100px' } },
        { name: "Inpris", align: "right", styles: { width: "5%", maxWidth: '100px' } },
        { name: "Marginal", align: "right", styles: { width: "5%", maxWidth: '100px' } },
        { name: "Pris", align: "right", styles: { width: "5%", maxWidth: '100px' } },
        { name: "Rabatt", align: "right", styles: { width: "5%", maxWidth: '100px' } },
        { name: "Slutpris", align: "right", styles: { width: "5%", maxWidth: '100px' } }
    ];

    handleOpenSearchPopup = () => {
        this.setState({
            openSearchPopup: true
        });
    };

    handleOpenedSearchPopup = () => {
        if (this.articleSearchFor.current) {
            this.articleSearchFor.current.focus();
        }
    };

    handleClosedSearchPopup = () => {
        this.setState({
            openSearchPopup: false,
            searchResults: []
        });
    };

    handleArticleSearch = async () => {
        const search_for = this.articleSearchFor.current.value;
        const article_group_name = this.articleGroupName.current.value;

        const max_items = 100;

        const searchParams = {
            search_for,
            article_group_name,
            max_items
        };

        let searchResults = [];
        try {
            const response = await findArticles(searchParams);
            searchResults = response.data.data;
        } catch (e) { }

        this.setState({
            searchResults
        });
    };

    handleArticleSelect = article => {
        if (article.active == 0) return;

        if ("function" === typeof this.props.onAddRow) {
            this.props.onAddRow(article);
        }

        this.setState({
            openSearchPopup: false,
            searchResults: []
        });
    };

    handleItemWillDrop = (items, item, realPathTo) => {
        if (realPathTo.length > 1) {
            // Item wants to become a child ...
            const parentRow = items[realPathTo[0]];
            if (item.infoboard_id > 0 || !parentRow.infoboard_id) {
                // ... but we wont let that happen
                return false;
            }
        }

        return true;
    };

    handleItemDropped = items => {
        this.props.onRowsSortEnd(items);
    };

    constructor(props) {
        super(props);
        this.autocomplete = null;
        this.addRowTextInput = React.createRef();
        this.articleSearchFor = React.createRef();
        this.articleGroupName = React.createRef();
        this.renderItem = this.renderItem.bind(this);

        this.state = {
            searchResults: [],
            openSearchPopup: false
        };
    }

    componentDidMount() {
        if (this.addRowTextInput.current) {
            // Do the autocomplete magic...
            this.autocomplete = new Awesomplete(this.addRowTextInput.current, {
                data: text => {
                    const article = this.props.articles.find(
                        article => article.article_number === text
                    );

                    return {
                        label:
                            article.article_number +
                            " " +
                            article.name + " (" + article.price_updated_at.substring(0, 10) + ")" +
                            (article.active == 0 ? " (inaktiverad)" : "") +
                            (article.in_stock == 0
                                ? " (beställningsvara)"
                                : parseInt(article.stock) > 0 ? " (" + article.stock + " i lager)" : ""
                            ),
                        value: article.article_number
                    };
                }
            });

            this.addRowTextInput.current.addEventListener(
                "awesomplete-selectcomplete",
                event => {
                    const match = this.props.articles.find(
                        article => article.article_number === event.text.value
                    );

                    if (match.active == 0) return;

                    event.target.value = "";
                    if (match) {
                        this.props.onAddRow(match);
                    }
                }
            );
        }
    }

    renderSummary() {
        return null;
        const {
            totalCost,
            totalExtraCost,
            totalTime,
            totalPurchasePrice,
            totalWeight,
            totalMargin,
            totalPrice,
            totalDiscount,
            totalPriceAfterDiscount
        } = this.props;

        return (
            <Fragment>
                {this.tableHeadings.map((heading, index) => {
                    if (index < 7) return '';

                    return (
                        <div
                            key={heading + index}
                            className={
                                "listCell p-2 text-" + heading.align + (index >= 7 && ' summarize')
                            }
                            style={heading.styles}
                        >
                            {(index == 7 && totalWeight)}
                            {(index == 8 && totalTime)}
                            {(index == 9 && totalExtraCost)}
                            {(index == 10 && totalCost)}
                            {(index == 11 && totalPurchasePrice)}
                            {(index == 12 && totalMargin)}
                            {(index == 13 && totalPrice)}
                            {(index == 14 && totalDiscount)}
                            {(index == 15 && totalPriceAfterDiscount)}
                            {(index == 16 && totalWeight)}
                        </div>
                    );
                })}
                <div className="listCell actions"></div>
            </Fragment>
        );
    }

    renderAddRowAction() {
        const { openSearchPopup, searchResults } = this.state;
        const { articleGroupsForSearchFunction: articleGroups } = this.props;

        return (
            <section className="listRowContainer listRowContainer--addNew">
                <div className="listRow">
                    <div className="p-2" style={{ width: '52%', maxWidth: '965px' }}>
                        <input
                            autoComplete="off"
                            className="form-control"
                            placeholder="Ange artikelnr. eller benämning"
                            ref={this.addRowTextInput}
                        />
                        <a
                            className="btn btn-icon btn-icon--search"
                            onClick={this.handleOpenSearchPopup}
                            role="button"
                            tabIndex="0"
                        >
                            Sök
                            </a>
                        <DefaultPopup
                            onClosePopup={this.handleClosedSearchPopup}
                            onOpenPopup={this.handleOpenedSearchPopup}
                            openPopup={openSearchPopup}
                            title="Sök bland artiklar"
                            contentClassName="content"
                        >
                            <Fragment>
                                <div className="row mt-3">
                                    <div className="col-sm-8 col-xl-6">
                                        <div className="form-group">
                                            <input
                                                autoComplete="off"
                                                className="form-control"
                                                onChange={() =>
                                                    this.handleArticleSearch()
                                                }
                                                placeholder="Ange artikelnr eller namn för att filtrera listan"
                                                ref={this.articleSearchFor}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-4 col-xl-6">
                                        <div className="form-group">
                                            <Select
                                                onChange={() =>
                                                    this.handleArticleSearch()
                                                }
                                                options={articleGroups}
                                                reference={
                                                    this.articleGroupName
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                {searchResults.length > 0 && (
                                    <Fragment>
                                        <div className="stripedRows">
                                            {searchResults.map(article => (
                                                <div
                                                    className={
                                                        "row pt-2 pb-2" +
                                                        (article.active == 0
                                                            ? " articleNotActive"
                                                            : "") +
                                                        (article.in_stock ==
                                                            0
                                                            ? " articleNotInStock"
                                                            : "")
                                                    }
                                                    key={article.id}
                                                >
                                                    <div className="col-sm-2 col-xl-1">
                                                        <a
                                                            onClick={() =>
                                                                this.handleArticleSelect(
                                                                    article
                                                                )
                                                            }
                                                            role="button"
                                                            tabIndex="0"
                                                            title={
                                                                article.active ==
                                                                    0
                                                                    ? "Artikeln inaktiverad"
                                                                    : "Välj för att lägga till"
                                                            }
                                                        >
                                                            {
                                                                article.article_number
                                                            }
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-6 col-xl-5">
                                                        <a
                                                            onClick={() =>
                                                                this.handleArticleSelect(
                                                                    article
                                                                )
                                                            }
                                                            role="button"
                                                            tabIndex="0"
                                                            title={
                                                                article.active ==
                                                                    0
                                                                    ? "Artikeln inaktiverad"
                                                                    : "Välj för att lägga till"
                                                            }
                                                        >
                                                            {article.name +
                                                                (article.active ==
                                                                    0
                                                                    ? " (inaktiverad)"
                                                                    : "") +
                                                                (article.in_stock ==
                                                                    0
                                                                    ? " (beställningsvara)"
                                                                    :
                                                                    parseInt(article.stock) > 0 ? " (" + article.stock + " i lager)" : ""
                                                                )}
                                                        </a>
                                                    </div>
                                                    <div className="col-sm-4 col-xl-5">
                                                        {
                                                            article.article_group_name
                                                        }
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </Fragment>
                                )}
                            </Fragment>
                        </DefaultPopup>
                    </div>

                    {this.renderSummary()}
                    {/* {new Array(16).fill("").map((_, index) => (
                        <div
                            key={index}
                            className={index === 15 ? "listCel p-2 actions" : "listCel p-2"}
                        >
                            &nbsp;
                        </div>
                    ))} */}
                </div>
            </section >
        );
    }

    renderItem({ handler, item: row, index }) {
        const {
            customer,
            globalSettings,
            isEditable,
            onChangeRow,
            onDeleteRow
        } = this.props;

        return (
            <CostEstimateRow
                customer={customer}
                data={row}
                dragHandler={handler}
                globalSettings={globalSettings}
                isEditable={isEditable}
                key={index}
                onChange={onChangeRow}
                onDelete={onDeleteRow}
                sortIndex={index}
                tableHeadings={this.tableHeadings}
            />
        );
    }

    render() {
        const { articles, isEditable, rows } = this.props;
        const {
            totalCost,
            totalExtraCost,
            totalTime,
            totalPurchasePrice,
            totalWeight,
            totalMargin,
            totalPrice,
            totalDiscount,
            totalPriceAfterDiscount
        } = this.props;

        if (this.autocomplete && articles) {
            // Populate the autocomplete list
            this.autocomplete.list = [
                ...articles.map(article => article.article_number)
            ];
        }

        rows.map((row, index) => {
            row.parentIndex = null;

            row.children.map(childRow => {
                childRow.parentIndex = index;

                const calc = new infoBoardsCalc();
                calc.setup(childRow);
                calc.setParentData(rows[index]);

                if (childRow.dont_recalculate_quantity) {
                    return;
                }

                childRow.quantity = calc.getQuantity();
            });
        });

        return (
            <article className="itemList itemList-costEstimateRows mt-3">
                <header>
                    <div className="listRow">
                        {this.tableHeadings.map(heading => {
                            return (
                                <div
                                    key={heading.name}
                                    className={
                                        "listCell p-2 text-" + heading.align
                                    }
                                    style={heading.styles}
                                >
                                    {heading.name}
                                </div>
                            );
                        })}
                        {isEditable && (
                            <div className="listCell actions">&nbsp;</div>
                        )}
                    </div>
                </header>
                <div className="listRows">
                    <Nestable
                        handler={
                            <span className="btn btn-icon btn-icon--dragndrop btn-icon--noText is-dragable" />
                        }
                        items={rows}
                        isDisabled={!isEditable}
                        maxDepth={2}
                        onChange={this.handleItemDropped}
                        onMove={this.handleItemWillDrop}
                        renderItem={this.renderItem}
                    />
                    {isEditable && this.renderAddRowAction()}
                </div>
                <footer>
                    <div className="listRow listRow--footer">
                        {this.tableHeadings.map((heading, index) => {
                            return (
                                <div
                                    key={heading + index}
                                    className={
                                        "listCell p-2 text-" + heading.align + (index >= 7 && ' summarize')
                                    }
                                    style={heading.styles}
                                >
                                    {(index == 7 && totalWeight)}
                                    {(index == 8 && totalTime)}
                                    {(index == 9 && totalExtraCost)}
                                    {(index == 10 && totalCost)}
                                    {(index == 11 && totalPurchasePrice)}
                                    {(index == 12 && totalMargin)}
                                    {(index == 13 && totalPrice)}
                                    {(index == 14 && totalDiscount)}
                                    {(index == 15 && totalPriceAfterDiscount)}
                                    {(index == 16 && totalWeight)}
                                </div>
                            );
                        })}
                        {isEditable && <div className="listCell actions" />}
                    </div>
                </footer>
            </article>
        );
    }
}

export default CostEstimateRows;
